import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { getService, services } from '../data/services';
import { company } from '../data/company';
import { PageHero } from '../components/PageHero';
import { ConsultationCta } from '../components/ConsultationCta';
const LIBRARY_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/9cf04be8-e35c-4213-877b-22b8f1cc61d1.jpg';
export function ServiceDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const service = slug ? getService(slug) : undefined;
  if (!service) {
    return <main data-id="element-349" data-mp="17s9ej2vjk3q5">
        <PageHero breadcrumb="Fiduciary Services" eyebrow="FIDUCIARY SERVICES" title="This service could not be found" description="The page you are looking for may have moved. Browse our full list of fiduciary services instead." data-id="element-350" data-mp="17rpspb2rsv6u" />
        <section className="bg-white" data-id="element-351" data-mp="3ogv9mib2t9cc">
          <div className="mx-auto max-w-shell px-6 py-24" data-id="element-352" data-mp="3ok0zw0vfyh9n">
            <Link to="/services" className="inline-flex items-center gap-2 border border-navy-900 px-7 py-4 text-[15px] font-medium text-navy-900 transition-colors duration-150 ease-out hover:bg-navy-900 hover:text-white" data-id="element-353" data-mp="18i1esp5nxg5m">
              View All Services
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-354" data-mp="13gvjqkoj5gsx" />
            </Link>
          </div>
        </section>
      </main>;
  }
  const related = services.filter(item => item.slug !== service.slug).slice(0, 3);
  return <main data-id="element-355" data-mp="ujbfr3za96em">
      <PageHero breadcrumb={service.title} eyebrow="FIDUCIARY SERVICES" title={service.title} description={service.summary} data-id="element-356" data-mp="uj1q5hi5h19g" />

      <section className="bg-white" data-id="element-357" data-mp="krynwcdhig8l">
        <div className="mx-auto grid max-w-shell gap-14 px-6 py-24 lg:grid-cols-[1.15fr_0.85fr] lg:gap-20" data-id="element-358" data-mp="kp2t2wwxo7od">
          <div data-id="element-359" data-mp="bqqyykwuyrr6">
            <p className="font-serif text-[22px] leading-relaxed text-navy-900" data-id="element-360" data-mp="br8u1e7sazxi">{service.intro}</p>

            <h2 className="mt-14 text-[12px] font-medium tracking-[0.22em] text-gold" data-id="element-361" data-mp="2dgg1jy7b6zr7">
              WHAT THIS INCLUDES
            </h2>
            <ul className="mt-6 divide-y divide-slate-200 border-y border-slate-200" data-id="element-362" data-mp="28nn29pum0jmi">
              {service.includes.map(item => <li key={item} className="flex gap-4 py-4" data-id="element-363" data-mp="1zoi3qjj1sqac">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-364" data-mp="1zq2xw81ga77o" />
                  <span className="text-[16px] leading-relaxed text-ink/80" data-id="element-365" data-mp="2we8viazyfzcg">{item}</span>
                </li>)}
            </ul>

            <h2 className="mt-14 text-[12px] font-medium tracking-[0.22em] text-gold" data-id="element-366" data-mp="2ne2kqwvn5dgz">
              WHO IT IS FOR
            </h2>
            <ul className="mt-6 space-y-3" data-id="element-367" data-mp="2ifsp6l608auu">
              {service.suitedFor.map(item => <li key={item} className="text-[16px] leading-relaxed text-ink/80" data-id="element-368" data-mp="1bz781ggk1m32">
                  — {item}
                </li>)}
            </ul>
          </div>

          <aside className="lg:sticky lg:top-8 lg:self-start" data-id="element-369" data-mp="3ing0h58pzq0q">
            <img src={LIBRARY_IMAGE} alt="A quiet private office where fiduciary matters are administered" className="h-56 w-full object-cover" data-id="element-370" data-mp="3il37lx1fbv8w" />
            <div className="border border-slate-200 border-t-0 bg-mist p-8" data-id="element-371" data-mp="3rlrmsv2k01nd">
              <h2 className="font-serif text-[22px] text-navy-900" data-id="element-372" data-mp="arl26e7ec4v">Talk through your situation</h2>
              <p className="mt-3 text-[15px] leading-relaxed text-ink/75" data-id="element-373" data-mp="57rriieytgwi">
                Send us the governing document and we will explain what the role requires and how
                we would handle it.
              </p>
              <Link to="/contact" className="mt-6 flex items-center justify-center gap-2 bg-navy-900 px-6 py-3.5 text-[15px] font-medium text-white transition-colors duration-150 ease-out hover:bg-navy-800" data-id="element-374" data-mp="f4d0feu3vc5m">
                Request a Consultation
              </Link>
              <a href={company.phoneHref} className="mt-3 block text-center text-[15px] font-medium text-navy-900 transition-colors duration-150 ease-out hover:text-gold-dark" data-id="element-375" data-mp="1pp90hs5kwj4z">
                {company.phoneDisplay}
              </a>
            </div>

            <nav className="mt-10" aria-label="Other services" data-id="element-376" data-mp="1uoc73h17ixf2">
              <h2 className="text-[12px] font-medium tracking-[0.22em] text-gold" data-id="element-377" data-mp="1up56ty1r0mnp">
                OTHER SERVICES
              </h2>
              <ul className="mt-5 divide-y divide-slate-200 border-t border-slate-200" data-id="element-378" data-mp="11zojheszjvyc">
                {related.map(item => <li key={item.slug} data-id="element-379" data-mp="1goucum556ryb">
                    <Link to={`/services/${item.slug}`} className="flex items-center justify-between gap-4 py-4 text-[16px] text-ink/80 transition-colors duration-150 ease-out hover:text-navy-900" data-id="element-380" data-mp="1gpvtr78ua8ny">
                      {item.title}
                      <ArrowRightIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-381" data-mp="j8x3hueht7az" />
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </aside>
        </div>
      </section>

      <ConsultationCta data-id="element-382" data-mp="2lwdqz24tjsi6" />
    </main>;
}